import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=627d502f&"
import script from "./HistoryView.vue?vue&type=script&lang=js&"
export * from "./HistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports